module.exports = __webpack_public_path__ + "static/media/login.f9130cbb.jpg";